import React, { FunctionComponent, useMemo } from "react"
import { Controller, useFieldArray, useFormContext } from "react-hook-form"
import { useHistory } from "react-router"
import ReactTable from "react-table-6"
import { collectionsList, spaceSizes } from "../../../api/Definitions"
import { Input } from "../../../components/Form"
import FormInput from "../../../components/Form/Inputs/FormInput"
import AsyncSelectInput from "../../../components/Form/Select/AsyncSelect"
import SelectInput from "../../../components/Form/Select/Select"
import { iResponse } from "../../../definitions/interfaces"
import { iRoles } from "../../../definitions/Roles"
import { get, handleDeleteData } from "../../../store/data/actions"
import { CreateRule } from "../../Packages/inspector/Overview"
import s from "../Users.less"

const tableColumns = [
  {
    Header: "Available Assets",
    accessor: "collection",
  },
  {
    accessor: "count",
    Header: "Remaining",
  },
]

const UserSubscription: FunctionComponent = () => {
  const history = useHistory()
  const { control, getValues } = useFormContext()
  const { fields, remove, append } = useFieldArray({
    name: "package.rules",
    control,
  })

  const {
    fields: oneTimeFields,
    remove: oneTimeRemove,
    append: oneTimeAppend,
  } = useFieldArray({
    name: "package.oneTime",
    control,
  })

  const data = getValues("usedFromPackage") || []

  return (
    <div className="scrollable container">
      <div className="row">
        <div className="col-6">
          <FormInput name="package.name" label="Name" />
          <FormInput
            type="number"
            name="package.artPiecesPerExhibition"
            label="Art pieces per exhibition"
          />
          <FormInput
            type="checkbox"
            name="package.isCustom"
            label="Is custom package?"
          />
          <Controller
            control={control}
            name="package.space"
            render={({ value, onChange }) => (
              <SelectInput
                value={value}
                onChange={onChange}
                options={spaceSizes}
                name="space"
                label="Space size"
                isMulti
              />
            )}
          />
        </div>
        <div className="col-6">
          <FormInput name="package.planId" label="Plan ID" />
          <FormInput name="package.subscriptionId" label="Subscription ID" />
        </div>
      </div>

      <h3 className={s.ruleTitle}>Rules</h3>
      {fields.map((field, index) => (
        <div className="row" key={field.id}>
          <div className="col-4">
            <Controller
              render={({ value, onChange }) => (
                <SelectInput
                  name={`package.rules[${index}].collection`}
                  options={collectionsList}
                  placeholder="Collection..."
                  value={value}
                  onChange={onChange}
                />
              )}
              name={`package.rules[${index}].collection`}
              defaultValue={field.collection}
            />
          </div>
          <div className="col-4">
            <Controller
              render={({ value, onChange }) => (
                <Input
                  value={value}
                  onChange={onChange}
                  name={`package.rules[${index}].count`}
                  placeholder="Count"
                  type="number"
                />
              )}
              name={`package.rules[${index}].count`}
              control={control}
              defaultValue={field.count}
            />
          </div>
          <div className="col-4">
            <div className="form-group">
              <div className="form-control">
                <button
                  className="btn-red"
                  onClick={() => {
                    remove(index)
                  }}
                  type="button"
                >
                  Remove
                </button>
              </div>
            </div>
          </div>
        </div>
      ))}
      <CreateRule append={append} />
      <h3 className={s.ruleTitle}>One time rules</h3>
      {oneTimeFields.map((field, index) => (
        <div className="row" key={field.id}>
          <div className="col-4">
            <Controller
              render={({ value, onChange }) => (
                <SelectInput
                  name={`package.oneTime[${index}].collection`}
                  options={collectionsList}
                  placeholder="Collection..."
                  value={value}
                  onChange={onChange}
                />
              )}
              name={`package.oneTime[${index}].collection`}
              defaultValue={field.collection}
            />
          </div>
          <div className="col-4">
            <Controller
              render={({ value, onChange }) => (
                <Input
                  value={value}
                  onChange={onChange}
                  name={`package.oneTime[${index}].count`}
                  placeholder="Count"
                  type="number"
                />
              )}
              name={`package.oneTime[${index}].count`}
              control={control}
              defaultValue={field.count}
            />
          </div>
          <div className="col-4">
            <div className="form-group">
              <div className="form-control">
                <button
                  className="btn-red"
                  onClick={() => {
                    oneTimeRemove(index)
                  }}
                  type="button"
                >
                  Remove
                </button>
              </div>
            </div>
          </div>
        </div>
      ))}
      <CreateRule append={oneTimeAppend} title="Create one time rule" />
      <div
        style={{ borderBottom: "1px solid", marginBottom: "20px" }}
        className="gradient-border"
      ></div>
      <ReactTable
        filterable={false}
        sortable={false}
        showPagination={false}
        showFilters={false}
        showPageJump={false}
        data={data}
        columns={tableColumns}
        pageSize={data.length}
      />
    </div>
  )
}

export default UserSubscription
